class CurrencyClass {
    constructor() {
        
    }

    format(price, isParseInt=true, addSymbol=' ₽') {
        let result = ''

        if (typeof price != 'undefined') {
            if (typeof price == 'number') {
                price = price.toString()
            }

            if (isParseInt) {
                price = parseInt(Math.round(price)).toString()
            }

            if (price.length > 0) {
                const testPrice = /^([\d]+)|([\d]+\.|,[\d]+)$/

                if (testPrice.test(price)) {
                    let str, integral, decimal, delim, 
                    regex = /\.|,[\d]+$/ig, 
                    delimPos = price.search(regex)

                    if (delimPos >= 0) {
                        integral = price.substr(0, delimPos)
                        decimal = price.substr(delimPos + 1)
                    } else {
                        integral = price
                        decimal = ''
                    }

                    str = integral

                    let blockSize = 3

                    if (str.length > blockSize) {
                        while (str.length > 0) {
                            if (str.length > blockSize) {
                                result = ' ' + str.substr(blockSize * -1, blockSize) + result
                                str = str.substr(0, str.length - blockSize)
                            } else {
                                result = str + result
                                str = ''
                            }
                        }

                        result = decimal.length > 0 ? result + '.' + decimal : result
                    } else {
                        result = str + (decimal.length > 0 ? '.' + decimal : '')
                    }
                } else {
                    result = price
                }
            }
        }

        return result + addSymbol
    }
}

const Currency = new CurrencyClass()

export default Currency